<ui-page-container>
  <mat-card>
    <mat-card-title>{{ 'Gestione schede' | translate }}</mat-card-title>
    <mat-card-content>
      <mat-tab-group
        animationDuration="0ms"
        [selectedIndex]="+activeTabIndex"
        (selectedTabChange)="tabChangeHandler($event)">
        <mat-tab [label]="'Oggetti Artistici' | translate">
          <app-cards-oac *ngIf="activeTabIndex === '0'"></app-cards-oac>
        </mat-tab>
        <mat-tab [label]="'Stampe' | translate">
          <app-cards-s *ngIf="activeTabIndex === '1'"></app-cards-s>
        </mat-tab>
        <mat-tab [label]="'Fotografie' | translate">
          <app-cards-f *ngIf="activeTabIndex === '2'"></app-cards-f>
        </mat-tab>
        <mat-tab [label]="'Matrici Incise' | translate">
          <app-cards-mi *ngIf="activeTabIndex === '3'"></app-cards-mi>
        </mat-tab>
        <mat-tab [label]="'Disegni' | translate">
          <app-cards-d *ngIf="activeTabIndex === '4'"></app-cards-d>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</ui-page-container>
